import { ReactNode } from "react";
import { ScoreDetailContext, ScoreDetailContextInitialValues } from "src/context/ScoreDetail/context";
import { DrilldownState } from "src/context/ScoreDetail/useDrilldown";

type PuckScoreDetailProviderProps = {
    children: ReactNode;
};

// Populate the custom context consumed by the TokenizedText component
export const PuckScoreDetailProvider = ({ children }: PuckScoreDetailProviderProps) => {
    const contextValue: ScoreDetailContextInitialValues = {
        score: {
            id: 0,
            title: "",
            type: "",
            improvement: "increase",
            datavizType: "donut",
            isActionPlanAvailable: false,
            isTargetAvailable: false,
            variations: [],
        },
        prevCampaignLabel: "",
        drilldownState: {
            drilldown: (_: DrilldownState) => {},
            state: [],
            reset: () => {},
            breadcrumbs: [],
            last: undefined,
        },
        tabConfig: {
            distribution: {
                link: (_scoreId) => "",
            },
            comparison: {
                link: (_scoreId) => "",
            },
            evolution: {
                link: (_scoreId) => "",
            },
        },
    };

    return <ScoreDetailContext.Provider value={contextValue}>{children}</ScoreDetailContext.Provider>;
};
